import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DialogType } from '@app/shared/models/dialog-type';

@Component({
  selector: 'vp-message-modal',
  templateUrl: './message-modal.component.html',
  providers: [BsModalService]
})
export class MessageModalComponent {
  title: string;
  message: string;
  dialogType: DialogType = DialogType.message;
  dialogTypeMap = DialogType;
  confirmed = false;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService
  ) { }

  onConfirmClick() {
    this.modalService.setDismissReason('confirm');
    this.confirmed = true;
    this.bsModalRef.hide();
  }

  onYesClick() {
    this.modalService.setDismissReason('yes');
    this.bsModalRef.hide();
  }

  onNoClick() {
    this.modalService.setDismissReason('no');
    this.bsModalRef.hide();
  }

  onCancelClick() {
    this.modalService.setDismissReason('esc');
    this.bsModalRef.hide();
  }
}
